import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "Store/configureStore";

export const addonsStateSelector = (state: RootState) => state.addons;

export const loadingAddonsSelector = createSelector(
  addonsStateSelector,
  addonsState => addonsState.loadingAddons
);

export const addonsDataSelector = createSelector(
  addonsStateSelector,
  addonsState => addonsState.data
);

export const addonsSelector = createSelector(
  addonsDataSelector,
  (_: RootState, params: { organizationId: string }) => params,
  (data, { organizationId }) => data?.[organizationId]
);

export const addonsCurrentSelector = createSelector(
  addonsSelector,
  addons => addons?.current
);

export const addonsAvailableSelector = createSelector(
  addonsSelector,
  addons => addons?.available
);

export const addonsErrorSelector = createSelector(
  addonsStateSelector,
  addonsState => addonsState?.error
);
